/**
 * @description: 年报服务--过期合同
 * @param {*}
 * @return {*}
 */
<template>
	<div class="user-management-container">
		<tabel-panel  
			ref="tabel" :rowTemplate="rowTemplate" api="ContractOldSearch"  
			:condition="conditionData" editType="pop" :autoSearch="true"
			:showCancelButton="false"
			@popConfirmButtonClick="popConfirmButtonClick" :clickRowSelected="false" 
			@customerRowDblClick="customerRowDblClick" :popToCustomer="true">
			
			<template v-slot:tabelTitleLeft>
				<div>过期合同</div>
			</template>
			
			<template v-slot:condition style="height: 200px;">
				<text-field
					v-model:value="conditionData.cid" 
					labelText="客户:"
					:clearable="true" type="select"
					:selectRemoteSearchData="selectOuguName"
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.did" 
					labelText="合同类型:"
					:clearable="true" type="select"
					:selectRemoteSearchData="selectWeiBaoName"
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.con" 
					labelText="合同编号:"
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.buyDate" 
					type="date"
					labelText="购买日期:"
					clearable
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.endDate" 
					type="date"
					labelText="截至日期:"
					clearable
					class="condition-container-input">
				</text-field>
			</template>
			
			<template v-slot:repairBtn="$opData">
				<div class="opration">
					<el-button type="text" @click="seeHandle($opData)">
						点击打开 
					</el-button>
				</div>
			</template>
		</tabel-panel>
		
		<el-dialog
			v-model="centerDialogVisible"
			width="30%" :show-close="false"
			center>
			<div >
				<img style="width:100%;" :src="Terminal_img" >
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import textField from "@/components/textField.vue"
	import delButton from "@/components/delButton.vue"
	import addButton from "@/components/addButton.vue"
	import controlButton from "@/components/controlButton.vue"
	import updateButton from "@/components/updateButton.vue"
	import tabelPanel from "@/components/tabelPanel.vue"
	import popDialog from "@/components/popDialog.vue"
	import tableApi from "@/api/tabel.js"
	import {
		symptomEdit,
		RepairProductCancel,
		MoneySave,
		BackFactorySave,
		RepairSave
	} from "@/api/index.js"
	import {
		errMsg,
		successMsg
	} from "@/notify/index.js"

	export default {
		name: "CusRepairList",
		components: {
			textField,
			addButton,
			delButton,
			tabelPanel,
			popDialog,
			updateButton,
			controlButton
		},
		data() {
			return {
				Terminal_img:"",
				centerDialogVisible: false,
				radio: null,
				loadShow: false,
				rowData: null,
				rowTemplate: [ 
					{
						headerLabel: "客户",
						width:180,
						editable: true,
						sortable:true,
						dataIndex: "CompanyName"
					},{
						headerLabel: "合同类型",
						width:100,
						dataIndex: "DicInfoName"
					},{
						headerLabel: "合同编号",
						width:100,
						sortable:true,
						dataIndex: "ContractNo"
					},{
						headerLabel: "购买日期",
						width:100,
						sortable:true,
						dataIndex: "BuyDate"
					},{
						headerLabel: "截至日期",
						width:100,
						sortable:true,
						dataIndex: "EndDate"
					},{
						headerLabel: "月限",
						width:100,
						sortable:true,
						dataIndex: "Month"
					},{
						headerLabel: "描述",
						width:250,
						dataIndex: "Appendix"
					},{
						headerLabel: "合同",
						slot: "repairBtn",
						width: null
					}],
				conditionData: {
					cid: null,
					did: null,
					con: null,
					buyDate: null,
					endDate: null,
					sn: null
					// cid	Int	公司id
					// did	int	品牌Id
					// con	string	合同号
					// buyDate	String	购买日期
					// endDate	String	截止日期
					// sn	String	SN号

				},
				
			}
		},
		methods: {
			// 合同查看功能
			seeHandle({data:{row}}){
				console.log(row,'合同过期查看合同')
				if(row.Terminal){
					this.Terminal_img=row.Terminal
					this.centerDialogVisible=true
				}else{
					errMsg("暂未有图片")
				}
				
				// row.Terminal &&	(this.Terminal_img=row.Terminal) && (this.centerDialogVisible=true)
			},
			/* rowDataNull(v){
				// let v == 0 ? null : v
				return v
			}, */
   /**
    * @description: 客户名称下拉框
    * @param {*}
    * @return {*}
    */			
			async selectOuguName()  {
				let source = await tableApi.CompanyInfo();
				if (source.code == 0) {
					let data = source.data.list.map(({
						Company_Id,
						CompName 
					}) => {
						return {
							label: CompName,
							value: Company_Id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
			//维修质保
			async selectWeiBaoName()  {
				let source = await tableApi.WeiBaoFangshi();
				if (source.code == 0) {
					let data = source.data.list.map(({
						Id,
						Name
					}) => {
						return {
							label: Name,
							value: Id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
			// 重新加载表格数据
			reloadData() {
				this.$refs.tabel.reloadData()
			},
			delSingleUser(row) {
				// let id = row.Id
				row.Month = 100
				console.log('id--', row)
				// RepairProductCancel({id}).then(data => {
				// 	if (data.code == 0) {
				// 		successMsg(data.message)
				// 		this.reloadData()
				// 	} else {
				// 		errMsg( data.message)
				// 	}
				// })
			},
			//弹层事件
			popConfirmButtonClick({
				slotData
			}) {
				console.log(slotData)
			},
			// 表格双击事件
			customerRowDblClick(row){
				console.log('row:',row)
				this.loadShow = true
				this.rowData = row
				this.$nextTick(()=>{
					this.$refs.getMenuList.showPopDialog(row, "报修明细","slot")
				})
				console.log('row:',this.rowData)
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";

	#suerSwitch .el-switch__core{
		width: 26px;
	}
	
	.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
		background: red;
	}
	
	.user-management-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		overflow: hidden;
		align-items: center;
		align-content: center;
		@include background_color("user-management-bg-color");
		 
		.del {
			margin-left: 10px;
		}

		.condition-container-input {
			width: 270px;
		}

		.opration {
			height: 100%;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			align-content: center;

			.item {
				&:nth-child(n+1) {
					margin-left: 10px;
				}
			}
		}
		.menuPowerBtn{
			// color:rgb(255, 255, 255)!important;
			// background:rgb(100,134,232)!important;
		}
		.menuPowerBOX{
			.el-button--default{
				width:90px;
				height:30px;
				color: #ffffff;
				background: rgb(100,134,232);
				border-radius: 4px;
			}
			.item {
				height: 30px;
				color: #ffffff !important;
				padding:10px 15px !important;
				background: rgb(100,134,232) !important; 
			}
		}
		#loadBOX{
			width: 100%;
			height: 100%;
			
			.text-field-container{
				display: flex;
				
			}
			.label-container{
			    display: flex;
			    width: fit-content;
			    height: fit-content;
			    padding: 10px;
			    box-sizing: border-box;
			}
		}
		.pop-dialog-conver{
			background:yellow ;
		}
		.pop-dialog-container{
			
		}
		.oprationTree{
			background-color: #ecf5ff;
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			padding: 25px 20px 15px 20px;
			
			.detailed-box{
				width: 100%;
				height: 100%;
				position: relative;
				border: 1px solid #99bce8;
				background-color: #f4f7f6;
				border-radius: 10px;
				
				
				.detailed-title{
					font-family:Microsoft YaHei;
					font-weight: normal;
					padding: 10px;
				}
				
				.text-field-container{
					background: #f4f7f6!important;
					margin: 10px 20px;
					width: 320px;
				}
				.user-management-container .condition-container-input{
					margin: 5px 10px;
				}
			
				.pop-dialogClose{
					position: absolute;
					top: 20px;
					right: 15px;
					
					.el-icon-close:before{
						font-size: 28px;
					}
					.el-icon-close:hover{
						color: #f92323;
					}
				}
			}
		}
		.pop-dialog-conver{
			display: block!important;
			width: 100%!important;
			height: 100%!important;
			
		}
		.control-button-container{
			margin: 25px auto;
			color: #409EFF;
		}
		.el-radio{
			display: flex;
			width: 300px;
			justify-content: space-evenly;
			flex-direction: row-reverse;
			padding: 20px 20px;
		}
		.el-radio-group{
			width: 100%;
			display: inherit;
			font-family: hanSan !important;
			font-size: 20px;
		}
		
	}
</style>
